module.exports = __webpack_public_path__ + "static/img/6.8f12052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/6.png
// module id = 9E3G
// module chunks = 0